
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipient",
      function () {
        return require("private-next-pages/recipient/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipient"])
      });
    }
  